// utils/audioStorage.js - IndexedDB for Audio File Persistence

const DB_NAME = 'SlidesprintAudioDB';
const STORE_NAME = 'audioFiles';
const DB_VERSION = 1;

/**
 * Open IndexedDB connection
 */
const openDB = () => {

  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => {
    
      reject(request.error);
    };
    
    request.onsuccess = () => {
      
      resolve(request.result);
    };

    request.onupgradeneeded = (event) => {
      
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'audioId' });
        
      }
    };
  });
};

/**
 * Save audio file to IndexedDB
 * @param {File} audioFile - The audio file object
 * @param {string} audioId - Unique ID for the audio
 * @param {Array} slideTimings - Array of slide timing data (optional)
 */
export const saveAudioToIndexedDB = async (audioFile, audioId, slideTimings = null) => {
  
  
  try {
    const db = await openDB();
    
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const audioData = {
      audioId: audioId,
      file: audioFile,
      name: audioFile.name,
      type: audioFile.type,
      size: audioFile.size,
      savedAt: new Date().toISOString(),
      slideTimings: slideTimings || null
    };

    
    
    await new Promise((resolve, reject) => {
      const request = store.put(audioData);
      request.onsuccess = () => {
      
        resolve();
      };
      request.onerror = () => {
        
        reject(request.error);
      };
    });


    if (slideTimings) {
  
    }
    db.close();
    
    return true;
  } catch (error) {
   
    return false;
  }
};

/**
 * Get audio file from IndexedDB
 * @param {string} audioId - Unique ID for the audio
 * @returns {Object|null} { file: File, slideTimings: Array } or null if not found
 */
export const getAudioFromIndexedDB = async (audioId) => {
  
  
  try {
    const db = await openDB();
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const store = transaction.objectStore(STORE_NAME);

   
    
    const audioData = await new Promise((resolve, reject) => {
      const request = store.get(audioId);
      request.onsuccess = () => {
        
        resolve(request.result);
      };
      request.onerror = () => {
    
        reject(request.error);
      };
    });

    db.close();

    if (audioData && audioData.file) {
      
      if (audioData.slideTimings) {
        
      }
      
      return {
        file: audioData.file,
        slideTimings: audioData.slideTimings || null
      };
    }

   
    return null;
  } catch (error) {
  
    return null;
  }
};

/**
 * Delete audio file from IndexedDB
 * @param {string} audioId - Unique ID for the audio
 */
export const deleteAudioFromIndexedDB = async (audioId) => {
  
  
  try {
    const db = await openDB();
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    await new Promise((resolve, reject) => {
      const request = store.delete(audioId);
      request.onsuccess = () => {
   
        resolve();
      };
      request.onerror = () => {
     
        reject(request.error);
      };
    });

  
    db.close();
  } catch (error) {
   
  }
};

/**
 * Clear old audio files (older than 7 days)
 */
export const clearOldAudioFiles = async () => {

  
  try {
    const db = await openDB();
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const store = transaction.objectStore(STORE_NAME);

    const allAudio = await new Promise((resolve, reject) => {
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });

    

    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

    let deletedCount = 0;
    for (const audio of allAudio) {
      const savedDate = new Date(audio.savedAt);
      if (savedDate < sevenDaysAgo) {
        await store.delete(audio.audioId);
        deletedCount++;
      }
    }

    if (deletedCount > 0) {
     
    } else {
      
    }

    db.close();
  } catch (error) {
    
  }
};